
import React from 'react';
import { useBreakpoint } from '@/hooks/use-mobile';
import { SectionContainer } from './section/SectionContainer';
import HeaderSection from './feature/HeaderSection';
import FeaturesGrid from './feature/FeaturesGrid';
import CallToAction from './feature/CallToAction';

const FeatureOverview = () => {
  const { isMobile, isTablet } = useBreakpoint();
  
  return (
    <section className="py-5 md:py-16 px-4 md:px-6 relative overflow-hidden">
      <div className="container mx-auto max-w-6xl relative z-10">
        {/* Section Header */}
        <HeaderSection 
          badge="AI-Powered Features"
          title="Everything You Need to Build Smart AI Tools Fast."
          description="From AI-powered assistants to dynamic forms and automated workflows, AskSpot gives you the tools to build, customize, and deploy AI solutions in minutes."
          className="pt-0 mb-8 md:mb-16" // Adding proper spacing
        />
        
        {/* Features Grid */}
        <FeaturesGrid />
        
        {/* Call to Action */}
        <CallToAction />
      </div>
    </section>
  );
};

export default FeatureOverview;
